
// 🔒 Call access restriction based on plan and trial
import { useEffect } from "react";

export function useCallAccessControl(userInfo) {
  useEffect(() => {
    if (!userInfo) return;

    // Experts don't need a plan — they receive calls, not make them
    const role = userInfo.role;
    if (role === 'expert') return;

    // Free plan (no planId) is allowed — don't block free-tier users
  }, [userInfo]);
}
